// Controls the #app-splash gate defined in index.html. The splash is in the
// HTML itself so it paints before any JS loads; this module only fades it out
// (after boot) and brings it back while a version check runs on tab return.
//
// The fail-safe timer is the contract that the gate can never trap anyone: if
// a check hangs or something throws, the splash fades anyway and the app is
// usable — at worst on the old bundle, which is no worse than before. For the
// case where this module never even runs (no JS, blocked/failed bundle), the
// splash carries a pure-CSS backstop: a .splash-error screen that reveals
// itself after a delay unless we stamp .splash-js-active here to cancel it.

const FADE_MS = 350; // keep in sync with the #app-splash transition in index.html
const FAILSAFE_MS = 4000;

const getSplash = () =>
  typeof document !== 'undefined' ? document.getElementById('app-splash') : null;

let removeTimer = null;
let failsafeTimer = null;

// Client JS is alive, so the fail-safe timers own the gate from here — cancel
// the CSS-only error reveal meant for bundles that never execute.
const markJsActive = (el) => el.classList.add('splash-js-active');

export const hideSplash = () => {
  const el = getSplash();
  if (!el) return;
  markJsActive(el);
  clearTimeout(failsafeTimer);
  clearTimeout(removeTimer);
  el.classList.add('splash-hidden');
  // display:none after the fade so the overlay can't intercept clicks.
  removeTimer = setTimeout(() => {
    el.style.display = 'none';
  }, FADE_MS + 50);
};

export const showSplash = () => {
  const el = getSplash();
  if (!el) return;
  markJsActive(el);
  clearTimeout(removeTimer);
  el.style.display = '';
  // Reflow so removing the class transitions from a rendered opacity:0 state
  // instead of snapping straight to visible.
  el.getBoundingClientRect();
  el.classList.remove('splash-hidden');
  clearTimeout(failsafeTimer);
  failsafeTimer = setTimeout(hideSplash, FAILSAFE_MS);
};

// Arms the fail-safe for the splash that's already visible from the HTML,
// without re-showing it. Called once at client boot.
export const armSplashFailsafe = () => {
  const el = getSplash();
  if (!el) return;
  markJsActive(el);
  clearTimeout(failsafeTimer);
  failsafeTimer = setTimeout(hideSplash, FAILSAFE_MS);
};
